// FE-SCRM-059 — Actor resolver hook for ActivityRowRichBody.
//
// Loads the team-member list once and returns a memoized
// member_id → display_name function. ActivityListTable + ActivityRail
// both call this hook at their top level so individual rows do not
// refetch.

import { useMemo } from "react";

import { useTeamMembersQuery } from "../AddOpportunity/hooks";

import type { ActorResolver } from "./ActivityRowRichBody";


export function useActorResolver(): ActorResolver {
  const team = useTeamMembersQuery();
  return useMemo<ActorResolver>(() => {
    const rows = team.data?.rows ?? [];
    const map = new Map<string, string>();
    for (const row of rows) {
      const name = `${row.first_name} ${row.last_name}`.trim()
        || row.email;
      map.set(row.member_id, name);
      if (row.user_id) map.set(row.user_id, name);
    }
    return (id: string) => map.get(id) ?? null;
  }, [team.data]);
}
